import Modal from '../../../../components/modal/Modal';
import { centsToDollars } from '../../../../services/account.service';
import { BREEDER_PAYMENTS_CONSTANTS, BUTTON_CONSTANTS, LABEL_CONSTANTS } from '../../../../constants/common';

interface MarkAsPaidModalProps {
  isOpen: boolean;
  outstandingBalanceCents: number;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const MarkAsPaidModal = ({ isOpen, outstandingBalanceCents, loading, onClose, onConfirm }: MarkAsPaidModalProps): JSX.Element => {
  const amountLabel = `$${centsToDollars(outstandingBalanceCents)}`;
  return (
    <Modal isOpen={isOpen} onClose={onClose} width={520} ignoreBackdrop>
      <div className="payment-history__mark-paid-modal">
        <div className="header">
          <h4>{LABEL_CONSTANTS.MARK_AS_PAID}</h4>
        </div>
        <div className="body">{BREEDER_PAYMENTS_CONSTANTS.MARK_AS_PAID_CONFIRMATION.replace('{amount}', amountLabel)}</div>
        <div className="footer">
          <button
            className="button blue inverted medium payment-history__mark-paid-cancel"
            type="button"
            onClick={onClose}
            disabled={loading}>
            {BUTTON_CONSTANTS.CANCEL}
          </button>
          <button
            className="button green medium payment-history__mark-paid-confirm"
            type="button"
            onClick={onConfirm}
            disabled={loading}>
            {LABEL_CONSTANTS.MARK_AS_PAID}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MarkAsPaidModal;
